import React, { Component } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TracksPopularLastWeek from "~/Components/Elements/TracksPopularLastWeek";
import TracksPopularLastWeekContainer from "~/Containers/TracksPopularLastWeekContainer";

class MessageBoardFooter extends Component {
  render() {
    return (
      <Row className="mb-footer">
        <Col xs={12}>
          <TracksPopularLastWeekContainer
            render={(props) => {
              return <TracksPopularLastWeek {...props} />;
            }}
          />
        </Col>
        <Col xs={12} style={{ marginBottom: "30px" }}>
          <h2>Records you might need...</h2>
          <iframe
            style={{ width: "100%", height: "210px", margin: "0 auto", textAlign: "center", display: "block", border: "0" }}
            src="//dreamchimney.com/tracks/util/iframe_kba.php?artist=cosmic+synth"
          ></iframe>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <div className="totd-header dark mb">
            <h4>Message Board Options</h4>
          </div>

          <ul className="mb-footer-links">
            <li>
              <Link to="/message-board/new">Add a new Topic</Link>
              <p>Anyone can add to the Message Board.</p>
            </li>
            <li>
              <Link to="/message-board/today">Today's Messages</Link>
              <p>Read the most recent messages.</p>
            </li>
          </ul>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <div className="totd-header dark mb">
            <h4>Also on Dream Chimney</h4>
          </div>
          <ul className="mb-footer-links">
            <li>
              <a href="/sleevery/" target="_blank">
                Sleevery
              </a>
              <p>the classiest record cover sleeves we've ever seen.</p>
            </li>
            <li>
              <a href="/oftheday/" target="_blank">
                ____ of the Day
              </a>
              <p>Wacky links and photos found during our day on the web.</p>
            </li>
            <li>
              <a href="/motw/" target="_blank">
                Mix of the Week
              </a>
              <p>Weekly music mixes.</p>
            </li>
          </ul>
        </Col>
      </Row>
    );
  }
}

export default MessageBoardFooter;
